import { useMantineTheme } from '@mantine/core'

export const RequiredMarker = () => {
  const theme = useMantineTheme()

  // eslint-disable-next-line react/jsx-no-literals
  return <span css={{ color: theme.colors.red[0] }}>*&nbsp;</span>
}
